var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSidebarMaximize = function SvgIconSidebarMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 13.94",
    strokeWidth: 0
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.98v1.96l10 .02V3.98ZM0 7.98v1.96l10 .02V7.98Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1.94,
    transform: "translate(0 12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 4.26a.5.5 0 0 0-.85.36v4.72a.5.5 0 0 0 .85.36l2.46-2.36a.51.51 0 0 0 0-.72Z"
  })));
};
export { SvgIconSidebarMaximize as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxMy45NCIgc3Ryb2tlLXdpZHRoPSIwIj4KICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxLjk0IiBmaWxsPSIjMDAwIi8+CiAgICA8cGF0aCBkPSJNMiw3VjguOTZsMTAsLjAyVjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtMy4wMikiIGZpbGw9IiMwMDAiLz4KICAgIDxwYXRoIGQ9Ik0yLDExdjEuOTZsMTAsLjAyVjExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTMuMDIpIiBmaWxsPSIjMDAwIi8+CiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMS45NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMikiIGZpbGw9IiMwMDAiLz4KICAgIDxwYXRoIGQ9Ik0xNC44NSw3LjI4YS41LjUsMCwwLDAtLjg1LjM2djQuNzJhLjUuNSwwLDAsMCwuODUuMzZsMi40Ni0yLjM2YS41MS41MSwwLDAsMCwwLS43MloiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtMy4wMikiIGZpbGw9IiMwMDAiLz4KPC9zdmc+Cg==";